import { render, staticRenderFns } from "./BtnLoader.vue?vue&type=template&id=0585fdaa&"
import script from "./BtnLoader.vue?vue&type=script&lang=js&"
export * from "./BtnLoader.vue?vue&type=script&lang=js&"
import style0 from "./BtnLoader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports